<style>
    .page-item {
        cursor: pointer;
    }
    h4 {
        text-transform: capitalize;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Laporan Pembelian</h1>
                <div class="section-header-breadcumb button">
                    <a href="javascript:" @click.prevent="goTo('/laporan/pembelian/daftar-pembelian')" class="btn btn-icon icon-left btn-primary mr-1"><i class="fa fa-dollar"></i> Daftar Pembelian</a>
                    <a href="javascript:" @click.prevent="goTo('/laporan/pembelian/per-produk')" class="btn btn-icon icon-left btn-info mr-1"><i class="fas fa-cube"></i> Pembelian Per Produk</a>
                    <a href="javascript:" @click.prevent="goTo('/laporan/pembelian/per-supplier')" class="btn btn-icon icon-left btn-light"><i class="fas fa-user"></i> Pembelian Per Supplier</a>
                </div>
            </div>
            <div class="section-body">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>Daftar Pembelian</h4>
                                <div class="card-header-form">
                                    <div class="input-group">
                                        <label class="mr-1 font-weight-bold">Tanggal Mulai</label>
                                        <vc-date-picker v-model="tanggal_mulai" :input-props='{class: "form-control",placeholder: "Tanggal Mulai",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-3">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        <label class="mr-1 font-weight-bold">Tanggal Selesai</label>
                                        <vc-date-picker v-model="tanggal_selesai" :input-props='{class: "form-control",placeholder: "Tanggal Selesai",style:"display:inline;"}'/>
                                        <div class="input-group-btn mr-4">
                                            <button class="btn btn-primary"><i class="fa fa-calendar"></i></button>
                                        </div>
                                        
                                        <button @click="setFilter()" class="btn btn-outline-primary mr-3">Filter</button>
                                        <a :href="siteUrl+'Laporan/exportExcel/pembelian?tanggal_mulai='+formatDate(tanggal_mulai)+'&tanggal_selesai='+formatDate(tanggal_selesai)+'&tipe='+url[1]" target="_blank" style="padding:7px 0px 0px 0px" class="btn btn-outline-info"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body p-0">
                                <div v-if="url[1] == 'pembelian'" class="table-responsive">
                                    <table class="table table-hover table-bordered table-md">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Tanggal Jatuh Tempo</th>
                                                <th>Nomor Invoice</th>
                                                <th>Nama Supplier</th>
                                                <th>Status</th>
                                                <th>Total IDR</th>
                                                <th>Sisa Tagihan IDR</th>
                                                <th>Total USD </th>
                                                <th>Sisa Tagihan USD </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="cursor:pointer;" v-for="list in transaksiList" v-bind:key="list.main.id_transaksi" @click="goDetailTransaksi(list.main.id_transaksi,list.main.tipe_transaksi)">
                                                <td>{{ list.no }}</td>
                                                <td> {{ list.main.tanggal_jatuh_tempo_pembayaran | moment("DD MMMM YYYY") }} </td>
                                                <td> {{ list.main.nomor_invoice }} </td>
                                                <td> {{ list.main.display_name }} </td>
                                                <td v-html="statusBayarCallback(list.main.status_lunas)"> </td>
                                                <td> {{ 'Rp. '+ currencyFormat(list.main.grand_total_idr) }}  </td>
                                                <td> {{ 'Rp. '+ currencyFormat(list.main.outstanding_idr) }} </td>
                                                <td> {{ '$ '+ currencyFormat(list.main.grand_total) }} </td>
                                                <td> {{ '$ '+ currencyFormat(list.main.outstanding) }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    
                                </div>
                                <div v-else-if="url[1] == 'produk'" class="table-responsive">
                                    <table class="table table-hover table-bordered table-md">
                                        <thead>
                                            <tr>
                                                <th>Kode Produk</th>
                                                <th>Nama Produk</th>
                                                <th>Kuantitas Terbeli</th>
                                                <th>Satuan</th>
                                                <th>Total Nilai Terbeli USD</th>
                                                <th>Total Nilai Terbeli IDR</th>
                                                <th>Harga Beli Rata-rata USD</th>
                                                <th>Harga Beli Rata-rata IDR</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="cursor:pointer;" v-for="list in transaksiList" v-bind:key="list.main.id_produk" @click="goDetailProduk(list.main.id_produk)">
                                                <td> {{ list.main.kode_produk }} </td>
                                                <td> {{ list.main.nama_produk }} </td>
                                                <td> {{ list.main.total_qty_transaksi }} </td>
                                                <td> {{ list.main.nama_satuan }} </td>
                                                <td> {{ '$ '+ currencyFormat(list.main.harga_total_usd_produk) }}  </td>
                                                <td> {{ 'Rp. '+ currencyFormat(list.main.harga_total_idr_produk) }} </td>
                                                <td> {{ '$ '+ currencyFormat(list.main.harga_satuan_usd_rata) }} </td>
                                                <td> {{ 'Rp. '+ currencyFormat(list.main.harga_satuan_idr_rata) }} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else-if="url[1] == 'supplier'" class="table-responsive">
                                    <pelanggan-table :dataList="transaksiList"></pelanggan-table>
                                </div>
                            </div>
                            <div class="card-footer text-right">
                                <nav class="d-inline-block">
                                    <ul class="pagination mb-0">
                                        <li class="page-item disabled">
                                            <a class="page-link" href="#" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                                        </li>
                                        <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                            <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#"><i class="fas fa-chevron-right"></i></a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'
import PelangganTable from './TablePelanggan.vue'

Vue.use(VModal)

export default {
    data() {
        return {
            jenis_pembayaran : '',
            transaksiList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            url : '',
            filter : '',
            tanggal_mulai : new Date(),
            tanggal_selesai : new Date(),
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.url = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.url = this.url.split('-');    
        this.init();
    },
    methods: {
        init: function() {
            if(this.url[1] == 'pembelian') {
                this.$root.is_loading = true;
                this.$http.get("Laporan/getLaporanPembelianList?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter+"&tanggal_mulai="+this.formatDate(this.tanggal_mulai)+"&tanggal_selesai="+this.formatDate(this.tanggal_selesai)).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Transaksi')
                    }
                    else {
                        this.transaksiList = result.data.detail.data;
                        this.totalRow = result.data.detail.totalRow;
                        this.last = Math.ceil(this.totalRow / this.perPage)
                        this.pagination = this.getPaging();
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });
            }else if(this.url[1] == 'produk') {
                this.$root.is_loading = true;
                this.$http.get("Laporan/getLaporanPembelianProdukList?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter+"&tanggal_mulai="+this.formatDate(this.tanggal_mulai)+"&tanggal_selesai="+this.formatDate(this.tanggal_selesai)).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Transaksi')
                    }
                    else {
                        this.transaksiList = result.data.detail.data;
                        this.totalRow = result.data.detail.totalRow;
                        this.last = Math.ceil(this.totalRow / this.perPage)
                        this.pagination = this.getPaging();
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });
            }else if(this.url[1] == 'supplier') {
                this.$root.is_loading = true;
                this.$http.get("Laporan/getLaporanPembelianSupplierList?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter+"&tanggal_mulai="+this.formatDate(this.tanggal_mulai)+"&tanggal_selesai="+this.formatDate(this.tanggal_selesai)).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Transaksi')
                    }
                    else {
                        this.transaksiList = result.data.detail.data;
                        this.totalRow = result.data.detail.totalRow;
                        this.last = Math.ceil(this.totalRow / this.perPage)
                        this.pagination = this.getPaging();
                    }
                    this.$root.is_loading = false;
                }, error => {
                    this.$root.is_loading = false;
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
            
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetailTransaksi: function(id_transaksi,type){
            var u = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
            this.$router.push({ path : '/pembelian/list/pembayaran-pembelian-detail/'+id_transaksi+'/'+type })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        goDetailProduk: function(id_produk) {
            this.$router.push({ path : '/produk/produk-detail/'+id_produk })
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        statusBayarCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        statusCallback: function(val) {
            if(val == 1){
                return '<span style="color:green;">Dibayar</span>'
            }else{
                return '<span style="color:red;">Belum Dibayar</span>'
            }
        },
        setFilter: function() {
            this.init();
        },
        showModalPayment: function() {
            this.$modal.show('make-payment');
        },
        hideModalPayment: function() {
            this.$modal.hide('make-payment');
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
    },
    components : {
        'pelanggan-table' : PelangganTable
    }
}
</script>


// WEBPACK FOOTER //
// src/components/laporan/Pembelian.vue